var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Task',{attrs:{"blink":"E38000246","target":"Surrey Heartlands","sizeMap":"alcohol","colorMap":"alcohol","showRiver":"false","allowRiverCross":"false","isPractice":"true"}})}
var staticRenderFns = []

export { render, staticRenderFns }